import type { Lead } from '@backend/src/frontend-mongo-interfaces/mongoose.gen';
import logger from 'logger';
import type { CloseLocations } from 'lib/locations';

const ALLOWED_DISTANCE = 50;

// This function is used to skip the location step.

// Only show the location step when a location is not already selected,
// or when the selected location is > 250 miles away
// or when the selected location is > 50 miles away AND there is a closer location

// So location is ok if:
// 1. There is a location selected
// 2. The selected location is within 250 miles of the address
// 3. The selected location is < 50 miles away OR it is the closest location
export const checkIfLocationIsOK = ({
  locationID,
  closeLocations,
}: {
  locationID: Lead['locationID'];
  closeLocations: CloseLocations;
}): boolean => {
  // Close locations are within 250 miles of the address.
  const foundLocationIndex = closeLocations.findIndex(
    (closeLocation) => closeLocation.location?.id === locationID?.toString(),
  );

  const foundLocation =
    foundLocationIndex > -1 ? closeLocations[foundLocationIndex] : undefined;

  const locationOK =
    typeof locationID === 'number' &&
    // The address is within 250 miles of the location.
    typeof foundLocation !== 'undefined' &&
    ((foundLocation.distance || 0) <= ALLOWED_DISTANCE ||
      foundLocationIndex === 0);

  logger.info('checkIfLocationIsOK', {
    locationID,
    closeLocations,
    locationOK,
  });

  return locationOK;
};

export default checkIfLocationIsOK;
